import {buildIssueViewerRoute as buildPrimaryIssueViewerRoute} from '@github-ui/preheat-issues-manager/issue-viewer-query'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

import {repoAppBuilder} from '@github-ui/repo-app-builder'

export function buildIssueViewerRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return buildPrimaryIssueViewerRoute(appBuilder)
}

export const issueViewerRoute = buildIssueViewerRoute(repoAppBuilder)
